import React from 'react';

const CrownOutlineIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      viewBox='0 0 20 20'
      fill='none'
      {...props}
    >
      <path
        d='M2.91007 6.72428L3.98173 15.8368H16.0184L17.0901 6.72428L13.7484 8.95178L10.0001 3.70428L6.25173 8.95178L2.91007 6.72428ZM2.33423 4.33678L5.8334 6.67011L9.32173 1.78678C9.39882 1.67875 9.50059 1.5907 9.61858 1.52995C9.73657 1.4692 9.86736 1.4375 10.0001 1.4375C10.1328 1.4375 10.2636 1.4692 10.3816 1.52995C10.4995 1.5907 10.6013 1.67875 10.6784 1.78678L14.1667 6.67011L17.6667 4.33678C17.7992 4.24865 17.9541 4.20028 18.1132 4.19739C18.2723 4.1945 18.4288 4.23721 18.5644 4.32046C18.7 4.40372 18.8089 4.52405 18.8783 4.66722C18.9476 4.8104 18.9746 4.97045 18.9559 5.12845L17.5867 16.7676C17.5629 16.9703 17.4654 17.1572 17.3129 17.2928C17.1603 17.4285 16.9633 17.5034 16.7592 17.5034H3.2409C3.03679 17.5034 2.83979 17.4285 2.68726 17.2928C2.53473 17.1572 2.43728 16.9703 2.4134 16.7676L1.04423 5.12761C1.02573 4.96968 1.0528 4.80975 1.12225 4.66671C1.1917 4.52367 1.30062 4.40348 1.43616 4.32033C1.5717 4.23718 1.7282 4.19455 1.88718 4.19747C2.04617 4.20038 2.201 4.24872 2.3334 4.33678H2.33423ZM10.0001 12.5034C9.55804 12.5034 9.13412 12.3279 8.82156 12.0153C8.509 11.7027 8.3334 11.2788 8.3334 10.8368C8.3334 10.3948 8.509 9.97083 8.82156 9.65827C9.13412 9.34571 9.55804 9.17011 10.0001 9.17011C10.4421 9.17011 10.866 9.34571 11.1786 9.65827C11.4911 9.97083 11.6667 10.3948 11.6667 10.8368C11.6667 11.2788 11.4911 11.7027 11.1786 12.0153C10.866 12.3279 10.4421 12.5034 10.0001 12.5034Z'
        fill='#9F9EA6'
      />
    </svg>
  );
};

export default CrownOutlineIcon;
